'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var NonReversibleMigrationError = /*#__PURE__*/function (_Error) {
  _inherits(NonReversibleMigrationError, _Error);

  var _super = _createSuper(NonReversibleMigrationError);

  function NonReversibleMigrationError(message) {
    var _this;

    _classCallCheck(this, NonReversibleMigrationError);

    _this = _super.call(this, message);
    _this.name = 'NonReversibleMigrationError';
    _this.code = NonReversibleMigrationError.code;
    _this.message = message;
    return _this;
  }

  return NonReversibleMigrationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NonReversibleMigrationError.code = 'ERR_NON_REVERSIBLE_MIGRATION';

var NotInitializedRepoError = /*#__PURE__*/function (_Error2) {
  _inherits(NotInitializedRepoError, _Error2);

  var _super2 = _createSuper(NotInitializedRepoError);

  function NotInitializedRepoError(message) {
    var _this2;

    _classCallCheck(this, NotInitializedRepoError);

    _this2 = _super2.call(this, message);
    _this2.name = 'NotInitializedRepoError';
    _this2.code = NotInitializedRepoError.code;
    _this2.message = message;
    return _this2;
  }

  return NotInitializedRepoError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NotInitializedRepoError.code = 'ERR_NOT_INITIALIZED_REPO';

var RequiredParameterError = /*#__PURE__*/function (_Error3) {
  _inherits(RequiredParameterError, _Error3);

  var _super3 = _createSuper(RequiredParameterError);

  function RequiredParameterError(message) {
    var _this3;

    _classCallCheck(this, RequiredParameterError);

    _this3 = _super3.call(this, message);
    _this3.name = 'RequiredParameterError';
    _this3.code = RequiredParameterError.code;
    _this3.message = message;
    return _this3;
  }

  return RequiredParameterError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

RequiredParameterError.code = 'ERR_REQUIRED_PARAMETER';

var InvalidValueError = /*#__PURE__*/function (_Error4) {
  _inherits(InvalidValueError, _Error4);

  var _super4 = _createSuper(InvalidValueError);

  function InvalidValueError(message) {
    var _this4;

    _classCallCheck(this, InvalidValueError);

    _this4 = _super4.call(this, message);
    _this4.name = 'InvalidValueError';
    _this4.code = InvalidValueError.code;
    _this4.message = message;
    return _this4;
  }

  return InvalidValueError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

InvalidValueError.code = 'ERR_INVALID_VALUE';

var MissingRepoOptionsError = /*#__PURE__*/function (_Error5) {
  _inherits(MissingRepoOptionsError, _Error5);

  var _super5 = _createSuper(MissingRepoOptionsError);

  function MissingRepoOptionsError(message) {
    var _this5;

    _classCallCheck(this, MissingRepoOptionsError);

    _this5 = _super5.call(this, message);
    _this5.name = 'MissingRepoOptionsError';
    _this5.code = MissingRepoOptionsError.code;
    _this5.message = message;
    return _this5;
  }

  return MissingRepoOptionsError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

MissingRepoOptionsError.code = 'ERR_MISSING_REPO_OPTIONS';
exports.InvalidValueError = InvalidValueError;
exports.MissingRepoOptionsError = MissingRepoOptionsError;
exports.NonReversibleMigrationError = NonReversibleMigrationError;
exports.NotInitializedRepoError = NotInitializedRepoError;
exports.RequiredParameterError = RequiredParameterError;